// removed by extract-text-webpack-plugin
module.exports = {"nf-solicitations-menu":"nf-solicitations-menu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperAdminMenu/SuperAdminMenu.scss
// module id = 5737
// module chunks = 1